/* eslint-disable */
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Set} from 'immutable';
import {
  FormRecordFieldContext,
  FormRecordFieldValueUpdateArgs,
  FormRecordFieldView,
  FormRecordFieldViewContext,
  FormRecordFieldViewModel,
  SetTmpReadonlyArgs,
  SetTmpReadonlyResult
} from '../../../../../util/form/form-utils';
import {Form} from '../../../../../lib/form/form.service';
import {Command} from '../../../../../util/command';
import {DocumentFileService} from '../../../../../lib/document/document-file.service';
import {noOpCommand} from '../../manager/form-record-inactivity-manager';
import {Observable, Subscription} from 'rxjs';
import {
  FieldNotification,
  FormRecordFieldNotifierService
} from "../../../../../lib/form/form-record-field-notifier.service";
import {WeightFactory} from "../../../../../util/weight-utils";
import {TranslateService} from "@ngx-translate/core";

/* eslint-enable */

@Component({
  selector: 'app-form-record-stock-summary-field',
  templateUrl: './form-record-stock-summary-field.component.html',
  styleUrls: ['./form-record-stock-summary-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormRecordStockSummaryFieldComponent implements FormRecordFieldView, OnInit, OnDestroy {


  WeightFactory = WeightFactory;
  public readonly selector: Form.FieldDataTypeSelector.STOCK_SUMMARY;

  formRecordFieldContext?: FormRecordFieldContext;

  model: Model = new Model();
  tmpReadonly: boolean = false;

  private filterNotificationSubscription: Subscription;
  private fieldId: number;

  constructor(private cdRef: ChangeDetectorRef,
              private translateService: TranslateService,
              private formRecordFieldNotifierService: FormRecordFieldNotifierService) {
  }

  ngOnInit() {
    this.filterNotificationSubscription
      = this.formRecordFieldNotifierService.subscribe(n => this.onFieldNotification(n));
  }

  ngOnDestroy(): void {
    this.formRecordFieldNotifierService.unsubscribe(this.filterNotificationSubscription);
  }

  setTmpReadonly(args: SetTmpReadonlyArgs): Command<SetTmpReadonlyResult> {
    return noOpCommand;
  }

  registerField(context: FormRecordFieldContext, originalModel?: any): any {
    if (originalModel) {
      this.model = originalModel;
    }
    this.formRecordFieldContext = context;
    this.fieldId = context.field.fieldId;
    const attrs = context.field.dataType.stockSummaryAttributes!;
    this.model.summarizedFields = attrs.summarizedFields;
    return this.model;
  }

  registerFieldViews(context: FormRecordFieldViewContext): void {
  }

  hasLocalFieldError(): boolean {
    return false;
  }

  validateWithInterrupt(): boolean {
    return false;
  }

  shouldNotifyAfterCreation(): boolean {
    return false;
  }

  afterFormRecordCreation(formRecordId: number): Observable<any> | undefined {
    return undefined;
  }

  createModel(): FormRecordFieldViewModel | undefined {
    return undefined;
  }

  updateValue(data: FormRecordFieldValueUpdateArgs) {
  }

  private get reqContext() {
    return this.formRecordFieldContext!;
  }

  getTitle(): string {
    if (this.formRecordFieldContext && this.formRecordFieldContext.field) {
      return this.formRecordFieldContext.field.title;
    } else {
      this.translateService.get('FORM_RECORD_STOCK_TITLE').subscribe(
        (result: string) => {
          return result;
        }
      );
    }
    return '';
  }

  private onFieldNotification(n: FieldNotification) {
    if (n.data && this.reqContext
      && n.formRecordUniqueId === this.reqContext.formRecordUniqueId
      && this.model.summarizedFields.contains(n.fieldId)) {
      this.model.addSummary(n.fieldId, n.data);
      this.cdRef.markForCheck();
    }
  }
}

class Model {
  summarizedFields: Set<number>;
  fieldSummaries: Map<number,StockFieldSummary>;
  summariesByCurrency: Map<String, StockFieldPriceSummary>;
  sumBaseAmount: number;
  sumWeight: number;

  constructor() {
    this.summarizedFields = Set.of();
    this.fieldSummaries = new Map<number,StockFieldSummary>();
    this.summariesByCurrency = new Map<string, StockFieldPriceSummary>();
    this.sumBaseAmount = 0;
    this.sumWeight = 0;
  }


  public addSummary(fieldId: number, summary: StockFieldSummary) {
    if (this.fieldSummaries.has(fieldId)) {
      this.minusSummary(this.fieldSummaries.get(fieldId)!);
    }
    this.plusSummary(summary);
    this.fieldSummaries.set(fieldId, summary);
  }

  private plusSummary(summary: StockFieldSummary) {
    if (!this.summariesByCurrency.has(summary.currencyCode)) {
      this.summariesByCurrency.set(summary.currencyCode, {
        currencyCode: summary.currencyCode,
        grossSumPrice: 0,
        netSumPrice: 0
      });
    }
    const s = this.summariesByCurrency.get(summary.currencyCode)!;
    s.grossSumPrice += summary.grossSumPrice;
    s.netSumPrice += summary.netSumPrice;
    this.summariesByCurrency.set(summary.currencyCode, s);
    this.sumBaseAmount += summary.sumBaseAmount;
    this.sumWeight += summary.sumWeight;
  }

  private minusSummary(summary: StockFieldSummary) {
    this.sumBaseAmount -= summary.sumBaseAmount;
    this.sumWeight -= summary.sumWeight;
    if (!this.summariesByCurrency.has(summary.currencyCode)) {
      return;
    } else {
      const s = this.summariesByCurrency.get(summary.currencyCode)!;
      s.grossSumPrice -= summary.grossSumPrice;
      s.netSumPrice -= summary.netSumPrice;
      this.summariesByCurrency.set(summary.currencyCode, s);
    }
  }
}

interface StockFieldSummary extends StockFieldPriceSummary {
  sumBaseAmount: number;
  sumWeight: number;
}

interface StockFieldPriceSummary {
  currencyCode: string;
  netSumPrice: number;
  grossSumPrice: number;
}
